import type {
	BasicCustomMailItemSendOptional,
	BasicCustomMailItemSendRequired,
	BasicCustomMailOptionalItemOverride,
	BasicCustomMailRequiredItemOverride,
	QuestionType,
} from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { PlanI18nInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelPolicy", "hotel", "hotelID", "planID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductPlanI18nFormModel = AutoGeneratorForFormModel<PlanI18nInputZodSchemaType, ExcludeKeys, QueryData>;

export type QueryData = {
	hotelEmailAddress: string;
	hotelPolicy: {
		questions: {
			questionID: string;
			required?: boolean | null | undefined;
			questionType: QuestionType;
			question: string;
			options?: string[] | null | undefined;
		}[];
	};
	customEmailSetting: {
		reservation: {
			atCreated: string | undefined;
			atUpdated: string | undefined;
			atCanceled: string | undefined;
			atCin: string | undefined;
		};
	};
	forReservation: {
		atCreated: BasicCustomMailRequiredItemOverride;
		atUpdated: BasicCustomMailRequiredItemOverride;
		atCanceled: BasicCustomMailRequiredItemOverride;
		atCheckInBefore_07days: BasicCustomMailOptionalItemOverride;
		atCheckInBefore_01days: BasicCustomMailOptionalItemOverride;
		atCheckInBefore_00days: BasicCustomMailOptionalItemOverride;
		atCheckOutAfter_01days: BasicCustomMailOptionalItemOverride;
	};
	// 基本メール設定
	basicCustomMailSetting?: {
		atCreated?: BasicCustomMailItemSendRequired;
		atUpdated?: BasicCustomMailItemSendRequired;
		atCanceled?: BasicCustomMailItemSendRequired;
		atCheckInBefore_07days?: BasicCustomMailItemSendOptional;
		atCheckInBefore_01days?: BasicCustomMailItemSendOptional;
		atCheckInBefore_00days?: BasicCustomMailItemSendOptional;
		atCheckOutAfter_01days?: BasicCustomMailItemSendOptional;
	};
	defaultPlanCustomMailSetting?: {
		atCreated?: BasicCustomMailRequiredItemOverride;
		atUpdated?: BasicCustomMailRequiredItemOverride;
		atCanceled?: BasicCustomMailRequiredItemOverride;
		atCheckInBefore_07days?: BasicCustomMailOptionalItemOverride;
		atCheckInBefore_01days?: BasicCustomMailOptionalItemOverride;
		atCheckInBefore_00days?: BasicCustomMailOptionalItemOverride;
		atCheckOutAfter_01days?: BasicCustomMailOptionalItemOverride;
	};
};
